import React from "react";
import { Box } from "@mui/material";

const MainContent = ({ children, desktopOpen = true }) => {
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        p: { xs: 1, sm: 2 },
        width: { sm: `calc(100% - ${desktopOpen ? 260 : 0}px)` },
        transition: "width 0.3s",
        overflowX: "auto", // Prevent body overflow
      }}
    >
      <Box sx={{ height: { xs: "64px", sm: "120px" } }} />
      {children}
    </Box>
  );
};

export default MainContent;
